import { StatisticsMetricGraphType } from '../../modules/statistics/types';

export const checkIfOnlyOneChartVisible = (
  displayMetrics: Record<StatisticsMetricGraphType, boolean>,
): boolean => {
  const trueValues = Object.values(displayMetrics).filter(v => !!v);

  return trueValues.length === 1;
};
